<template>
  <fragment>
    <AppBody title="Vendas / Cupom de Desconto" :subtitle="pageSubtitle">
      <div class="cupom-dados-cadastrais">
        <v-row>
          <v-col cols="6">
            <label class="input-labels" required> Código do Cupom </label>
            <v-text-field
              solo
              placeholder="Insira o código"
              maxlength="16"
              counter="16"
              v-model="$cupom_desconto.cadastro.codigo"
              type="text"
              class="textinput"
              :error-messages="$cupom_desconto.cadastro.error.codigo"
              @input="$cupom_desconto.cadastro.error.codigo = []"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <label required class="input-labels">Status</label>
            <v-select
              height="48"
              solo
              :items="$cupom_desconto.status"
              item-text="key"
              item-value="value"
              v-model="$cupom_desconto.cadastro.status"
              :error-messages="$cupom_desconto.cadastro.error.status"
              @input="$cupom_desconto.cadastro.error.status = []"
              type="text"
              class="textinput"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="input-labels" required>
              Data de Validade (início)
            </label>
            <v-text-field
              solo
              placeholder="dd/mm/aaaa hh:mm"
              v-model="$cupom_desconto.cadastro.dthr_val_ini"
              append-icon="mdi-calendar-blank-outline"
              v-mask="'##/##/#### ##:##'"
              type="text"
              class="textinput"
              :error-messages="$cupom_desconto.cadastro.error.dthr_val_ini"
              @input="$cupom_desconto.cadastro.error.dthr_val_ini = []"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="input-labels" required>
              Data de Validade (Fim)
            </label>
            <v-text-field
              solo
              placeholder="dd/mm/aaaa hh:mm"
              v-model="$cupom_desconto.cadastro.dthr_val_fim"
              append-icon="mdi-calendar-blank-outline"
              v-mask="'##/##/#### ##:##'"
              type="text"
              class="textinput"
              :error-messages="$cupom_desconto.cadastro.error.dthr_val_fim"
              @input="$cupom_desconto.cadastro.error.dthr_val_fim = []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="input-labels"> Quantidade </label>
            <v-text-field
              solo
              placeholder="Insira a quantidade"
              v-model="$cupom_desconto.cadastro.quantidade"
              type="number"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="input-labels"> Quantidade por Consumidor </label>
            <v-text-field
              solo
              placeholder="Insira a quantidade"
              v-model="$cupom_desconto.cadastro.limite_uso"
              type="number"
              class="textinput"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="input-labels"> Tipo de Desconto </label>
            <v-select
              height="48"
              solo
              :items="$cupom_desconto.tipo_desconto"
              placeholder="Defina o tipo de desconto"
              item-text="key"
              item-value="value"
              v-model="$cupom_desconto.cadastro.tipo_desconto"
              type="text"
              class="textinput"
            >
            </v-select>
          </v-col>
          <v-col
            cols="6"
            v-if="$cupom_desconto.cadastro.tipo_desconto == 'VALOR'"
          >
            <label required class="input-labels">Valor do Desconto</label>
            <VuetifyMoney
              v-model="$cupom_desconto.cadastro.valor_desconto"
              :options="options5"
              :classes="'textinput'"
              :errorMessages="$cupom_desconto.cadastro.error.valor_desconto"
              @input="$cupom_desconto.cadastro.error.valor_desconto = []"
            />
          </v-col>
          <v-col cols="6" v-else>
            <label required class="input-labels">
              Percentual do Desconto
            </label>
            <v-text-field
              solo
              placeholder="0"
              v-model="$cupom_desconto.cadastro.perc_desconto"
              type="number"
              prefix="%"
              :errorMessages="$cupom_desconto.cadastro.error.perc_desconto"
              @input="$cupom_desconto.cadastro.error.perc_desconto = []"
              class="textinput"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row :class="!isAdmin ? 'mb-3' : ''">
          <v-col
            cols="6"
            v-if="$cupom_desconto.cadastro.tipo_desconto == 'PERCENTUAL'"
          >
            <label class="input-labels" required
              >Valor máximo de desconto no pedido</label
            >
            <VuetifyMoney
              v-model="$cupom_desconto.cadastro.valor_max_desconto"
              :options="options5"
              :classes="'textinput'"
              :error-messages="
                $cupom_desconto.cadastro.error.valor_max_desconto
              "
              @input="$cupom_desconto.cadastro.error.valor_max_desconto = []"
            />
          </v-col>
          <v-col cols="6" v-else>
            <label class="input-labels" required>
              Valor mínimo do pedido
            </label>
            <VuetifyMoney
              v-model="$cupom_desconto.cadastro.valor_min_desconto"
              :options="options5"
              :classes="'textinput'"
              :error-messages="
                $cupom_desconto.cadastro.error.valor_min_desconto
              "
              @input="$cupom_desconto.cadastro.error.valor_min_desconto = []"
            />
          </v-col>
          <v-col cols="6" v-if="isAdmin">
            <div class="produtos-add-edit-container02 secondary">
              <div class="produtos-add-edit-container03">
                <v-checkbox
                  v-model="$cupom_desconto.cadastro.marketplace"
                  label="Cupom Marketplace"
                >
                </v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col v-else cols="6">
            <label class="input-labels"> Eventos </label>
            <v-autocomplete
              v-model="$cupom_desconto.cadastro.produto"
              :items="this.allEvents"
              :item-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              solo
              label="Selecione os Eventos"
              multiple
              chip
              deletable-chips
              class="textDropdown mb-n8"
              clearable
              clear-icon="mdi-close-circle-outline"
              :error-messages="$cupom_desconto.cadastro.error.produto"
              @input="
                $cupom_desconto.cadastro.error.produto = [];
                $cupom_desconto.cadastro.variacao = [];
              "
              item-text="descricao"
              item-value="idproduto"
              no-data-text="Nenhum evento encontrado"
              return-object
            >
              <template v-slot:selection="{ item }">
                <v-chip close @click:close="removeItem(item)">{{
                  item.descricao
                }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="isAdmin" cols="6">
            <label class="input-labels"> Eventos </label>
            <v-autocomplete
              v-model="$cupom_desconto.cadastro.produto"
              :items="this.allEvents"
              :item-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              solo
              label="Selecione os Eventos"
              multiple
              chip
              deletable-chips
              class="textDropdown"
              clearable
              clear-icon="mdi-close-circle-outline"
              :error-messages="$cupom_desconto.cadastro.error.produto"
              @input="
                $cupom_desconto.cadastro.error.produto = [];
                $cupom_desconto.cadastro.variacao = [];
              "
              item-text="descricao"
              item-value="idproduto"
              no-data-text="Nenhum evento encontrado"
              return-object
            >
              <template v-slot:selection="{ item }">
                <v-chip close @click:close="removeItem(item)">{{
                  item.descricao
                }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="showTickets" cols="6">
            <label class="input-labels"> Ingresso </label>
            <v-autocomplete
              v-model="$cupom_desconto.cadastro.variacao"
              :items="$cupom_desconto.variations"
              :item-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              solo
              :hint="hintTicket"
              persistent-hint
              multiple
              chips
              deletable-chips
              class="textDropdown"
              label="Selecione o Ingresso"
              clearable
              clear-icon="mdi-close-circle-outline"
              :error-messages="$cupom_desconto.cadastro.error.ingreso"
              @input="$cupom_desconto.cadastro.error.ingresso = []"
              item-text="descricao"
              item-value="idproduto_variacao"
              no-data-text="Nenhum ingresso encontrado"
            >
            </v-autocomplete>
            <template v-slot:selection="[{ item }]">
              <v-chip close @click:close="removeTicket(item)">{{
                item.descricao
              }}</v-chip>
            </template>
          </v-col>
        </v-row>

        <RegistrationActions :actions="actions"></RegistrationActions>
      </div>
    </AppBody>
  </fragment>
</template>

<script>
import CupomMixins from "@/mixins/Cupom.mixins.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CupomDescontoSettings",
  metaInfo: {
    title: "Cupons de Descontos | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Cupons de Descontos | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  mixins: [CupomMixins],
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    VuetifyMoney: () => import("@/components/global/VuetifyMoney.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
  },
  data() {
    return {
      ingresso: this.$cupom_desconto.cadastro.ingresso,
      actions: [
        {
          name: "Salvar",
          action: () => this.saveCoupoun(),
          loading: this.$cupom_desconto.cadastro.loading,
        },
        {
          name: "Cancelar",
          action: () => this.$router.push({ name: "discountCoupon" }),
        },
      ],
      hintTicket: "ℹ️ Esta opção está disponível apenas no ElevenTickets.com.",
    };
  },
  methods: {
    ...mapActions(["fetchEvents", "fetchEventsOfAnyStore"]),
    saveCoupoun() {
      this.$cupom_desconto.validarCadastro(this.routeType);
    },
    removeItem(item) {
      this.$cupom_desconto.cadastro.produto =
        this.$cupom_desconto.cadastro.produto.filter(
          produto => produto.idproduto !== item.idproduto
        );
    },
    removeTicket(item) {
      this.$cupom_desconto.cadastro.ingresso =
        this.$cupom_desconto.cadastro.ingresso.filter(
          ingresso => ingresso !== item.idprod_variacao
        );
    },
    filterSelectedProducts() {
      if (typeof this.$cupom_desconto.cadastro.produto[0] === "string") {
        let filteredProduct = [];
        this.$cupom_desconto.cadastro.produto.forEach(prod => {
          const selectedProductId = prod;
          filteredProduct.push(
            this.allEvents.find(
              produto => produto.idproduto === selectedProductId
            )
          );

          if (filteredProduct) {
            this.$cupom_desconto.cadastro.produto = filteredProduct;
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters(["allEvents", "storeSequencial"]),
    routeType() {
      return this.$route.params.type;
    },
    pageSubtitle() {
      const path = this.$route.path;
      if (path === "/vendas/cupom-desconto/cadastrar") {
        return "Cadastrar - Cupom de Desconto";
      } else {
        return "Editar - Cupom de Desconto";
      }
    },
    showTickets() {
      return (
        this.$cupom_desconto.cadastro.produto.length === 1 &&
        this.$cupom_desconto.variations.length > 0
      );
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
    eventsWithProducts() {
      const products = this.allEvents;

      const hasTickets = products.filter(produto => {
        const variacoes_produto = produto.variantes?.variacoes_produto;

        return variacoes_produto?.length >= 1;
      });

      return hasTickets;
    },
    tickets() {
      return this.$cupom_desconto.variations;
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
    "$store.getters.storeSequencial"() {
      if (this.storeSequencial) {
        this.fetchEvents({
          producerId: this.storeSequencial,
          filtro: [],
          periodo_valido: true,
        });
      }
    },
    "$cupom_desconto.cadastro.tipo_desconto"(e) {
      if (e) {
        this.$cupom_desconto.cadastro.valor_desconto = 0;
        this.$cupom_desconto.cadastro.perc_desconto = 0;
        this.$cupom_desconto.cadastro.valor_max_desconto = 0;
        this.$cupom_desconto.cadastro.valor_min_desconto = 0;
      }
    },
    "$cupom_desconto.cadastro.produto"(produto) {
      if (produto) {
        this.$cupom_desconto.variations =
          produto[0]?.variantes?.variacoes_produto;
      }
    },
    "$cupom_desconto.cadastro.marketplace"(e) {
      this.$cupom_desconto.cadastro.produto = [];
      if (e) {
        this.fetchEventsOfAnyStore({
          filtro: [],
          periodo_valido: false,
        });
      } else {
        this.fetchEvents({
          producerId: this.storeSequencial,
          filtro: [],
        });
      }
    },
  },
  mounted() {
    this.filterSelectedProducts();
    this.fetchEvents({
      producerId: this.storeSequencial,
      filtro: [],
    });
  },
  destroyed() {
    this.$cupom_desconto.clearFieldsCupom("CADASTRO");
  },
};
</script>
<style scoped>
html {
  scroll-behavior: smooth;
}

.btn-top {
  height: 48px !important;
  width: 48px !important;
  padding: 1.25rem 0;
  border-radius: 0.625rem;
  color: var(--dl-color-gray-white) !important;
  font-size: 0.875rem !important;
  background-color: #393939 !important;
  bottom: -58px;
  z-index: 99;
}
.cupom-dados-cadastrais {
  width: 100%;
  margin: 20px 0px 20px 0px;
}
.produtos-add-edit-container02 {
  flex: 0 0 auto;
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  border-radius: 20px;
  flex-direction: row;
  justify-content: center;
  background-color: #c9c9c9;
  margin-top: 23px;
}

.produtos-add-edit-container03 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px 15px 10px 15px;
}
</style>
